<template lang="pug">
form#waiver-form(
  name="waiver-form"
  @submit.prevent="submit"
  novalidate
)
  .modal-card
    header.modal-card-head
      p.modal-card-title(v-once) {{ title }}
    section.modal-card-body
      b-field(label="Name")
        b-input(
          :value="waiver.name"
          @input="set($event, 'name')"
        )
      b-field(
        label="Body"
        :message="isNew ? '' : 'The body cannot be edited. To make changes, create a new waiver.'"
      )
        b-input(
          type="textarea"
          rows="6"
          :disabled="!isNew"
          :value="waiver.body"
          @input="set($event, 'body')"
        )
    footer.modal-card-foot
      button.button.is-success(
        type="submit"
        :class="{ 'is-loading': settings.submitting }"
      ) Save Waiver
</template>

<script>
import { mapGetters } from 'vuex';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'waiver-form',
  computed: {
    ...mapGetters({
      waiver: getters.GET_WAIVER,
    }),
    isNew() {
      return this.waiver.id === undefined;
    },
    title() {
      return this.isNew ? 'New Waiver' : `Edit Waiver: ${this.waiver.name}`;
    },
  },
  data() {
    return {
      settings: {
        submitting: false,
      },
    };
  },
  methods: {
    set(val, key) {
      this.$store.commit(mutations.SET_WAIVER_FIELD, {
        key,
        val,
      });
    },
    async submit() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.settings.submitting = true;
        const action = this.isNew ? actions.DO_CREATE_WAIVER : actions.DO_UPDATE_WAIVER;
        const payload = {
          id: this.waiver.id,
          body: this.waiver.body,
          name: this.waiver.name,
        };
        const response = await this.$store.dispatch(action, payload);
        this.$parent.close();
        this.settings.submitting = false;
        this.$store.commit(mutations.SET_APP_SNACKBAR, {
          type: 'is-success',
          message: response.message,
        });
        this.$store.commit(mutations.SET_EVENTS_REFRESH, true);
      }
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/WaiverForm.vue